import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { EnvironmentService, WindowService } from '@big-direkt/utils/environment';
import { PlatformService } from '@big-direkt/utils/shared';

export const canActivateBlacklistedUrlsGuard: CanActivateFn = (_route, state) => {
    const environmentService = inject(EnvironmentService);
    const platformService = inject(PlatformService);
    const windowService = inject(WindowService);

    const { routerBlacklistedUrls } = environmentService;

    if (!routerBlacklistedUrls) {
        return true;
    }

    if (!RegExp(routerBlacklistedUrls, 'i').test(state.url)) {
        return true;
    }

    if (platformService.isPlatformServer()) {
        return false;
    }

    const documentRef = windowService.document();
    documentRef.location.assign(`${documentRef.location.origin}${state.url}`);

    return false;
};
